"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitch = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ToggleSwitch = _ref => {
  let {
    active,
    onChange,
    label,
    transitionTime,
    easing,
    color
  } = _ref;
  const tt = transitionTime || 100,
        e = easing || 'ease-out';
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toggleSwitch ".concat(active ? 'active' : ''),
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      cursor: 'default'
    },
    onClick: () => onChange(!active)
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 132.29166 132.29167",
    height: "55",
    width: "55" // height="35" width="35"

  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m 38.052687,47.864419 h 54.916086 c 27.034327,2.305319 25.559797,39.054731 0,40.30747 H 38.075448 C 10.11119,87.499017 11.297192,48.014766 38.052687,47.864419 Z",
    className: 'track'
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "toggleSwitch ".concat(active ? 'active' : ''),
    fill: active ? 'dodgerblue' : 'grey',
    cx: active ? 94.778557 : 35.651833,
    cy: "68.430901",
    r: "34",
    style: {
      transition: "cx ".concat(tt, "ms ").concat(e, ", fill ").concat(tt, "ms ").concat(e)
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginLeft: '10px',
      color
    }
  }, label)));
};

exports.ToggleSwitch = ToggleSwitch;